'use client';
import React, { useState } from 'react';
import Image from 'next/image';
import '@/app/main.css';

const faqs = [
  {
    question: "What is WhatsApp marketing, and how can it help my business?",
    answer: "WhatsApp marketing uses the WhatsApp platform to connect with your customers through direct messages, promotions, updates, and support. It helps build trust, drive engagement, and boost conversions with highly personalized communication."
  },
  {
    question: "What types of messages can I send through WhatsApp marketing?",
    answer: "You can send promotional offers, product updates, event reminders, order confirmations, appointment alerts, and customer service responses. All messages are designed to be timely, relevant, and compliant with WhatsApp’s business policies."
  },
  {
    question: "Do you use the official WhatsApp Business API?",
    answer: "Yes. We use the official WhatsApp Business API to ensure secure, scalable, and compliant messaging for businesses. This allows bulk messaging, chatbot automation, and integration with your CRM or e-commerce platforms."
  },
  {
    question: "Can I personalize messages for different customer segments?",
    answer: "Absolutely. We help you segment your audience and craft personalized messages based on behavior, preferences, and demographics — increasing engagement and conversion rates significantly."
  },
  {
    question: "How do you track the performance of WhatsApp campaigns?",
    answer: "We provide detailed analytics on message delivery, open rates, clicks, and customer responses. This helps you measure ROI and continuously improve your communication strategy for better results."
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div className="col text-center py-5 mt-5" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
        <h3>FAQ's</h3>
      </div>

      {/* Shapes */}
      <Image src="/shape1.svg" width={202} height={202} alt="shape" className="shape1" />
      <Image src="/shape2.svg" width={22} height={22} alt="shape" className="shape2 rotateme" />

      <div className="faq-area ptb-20">
        <div className="container" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
          <div className="faq-accordion accordion">
            {faqs.map((item, index) => (
              <div key={index} className="accordion__item">
                <div
                  className="accordion__heading faq-heading"
                  role="heading"
                  aria-level={3}
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="500"
                  data-aos-once="true"
                >
                  <div
                    className="accordion__button"
                    role="button"
                    tabIndex={0}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <span
  className={`transition-colors duration-200 cursor-pointer 
    hover:text-purple-600 
    ${openIndex === index ? "text-purple-600 font-semibold" : ""}`}
>{item.question}</span>
                  </div>
                </div>
                {openIndex === index && (
                  <div className="accordion__panel faq-ans">
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqSection;
